// @ts-nocheck
/* eslint-disable */
export const llaPlatformArrowUpFullIcon = {
    data: `<svg viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.375 5.54159L6 0.958252L1.625 5.54159" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 13.0417V1.79175" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-up-full' as const
};